import angular from 'angular';
import cartComponent from './cart.component';
import CartService from './cart.service';
import cartConfig from './cart.config';
import ProductCommentModalController from './product-comment-modal/product-comment-modal.controller';
import CreateTemplateModalController from './create-template-modal/create-template-modal.controller';
import GuestUserController from './modal-logistic/modal-logistic.controller';
import CartSellerModalController from './modal-cart-seller/modal-cart-seller.controller';
import CommentCartModalController from './modal-comment-cart/modal-comment-cart.controller';
import ModalMoraController from './modal-mora/modal-mora.controller';

let cartModule = angular.module('app.cart',[])
  .component('cart', cartComponent)
  .controller('ProductCommentModalController', ProductCommentModalController)
  .controller('CommentCartModalController', CommentCartModalController)
  .controller('CreateTemplateModalController', CreateTemplateModalController)
  .controller('CartSellerModalController', CartSellerModalController)
  .controller('GuestUserController', GuestUserController)
  .controller('ModalMoraController', ModalMoraController)
  .service('CartService', CartService)
  .config(cartConfig);

export default cartModule;



/** WEBPACK FOOTER **
 ** ./www/components/cart/cart.js
 **/